let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cMC69")).then(() => parcelRequire('7aneS'));